import Comment from 'assets/icons/fa/comment-alt.svg'

export default Comment
